module.exports = __webpack_public_path__ + "blueprint-purple-dark-no-labels-selector.1f649290806292922fc6.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/blueprint-purple-dark-no-labels-selector.png
// module id = ../../../../../src/assets/img/blueprint-purple-dark-no-labels-selector.png
// module chunks = main